import { LegalLayout, Lang, Sec, P, Divider, CONTACT_EMAIL, SITE_URL } from '@/components/LegalLayout';

export default function AiNotice() {
  return (
    <LegalLayout
      title="Informacja o AI / AI Notice"
      subtitle="Life Leverage OS — Pewnosc Siebie AI"
      updated="Ostatnia aktualizacja / Last updated: czerwiec 2026 / June 2026"
    >
      <Lang code="PL" label="Polski">
        <Sec title="Funkcje AI w aplikacji">
          <P>
            Life Leverage OS zawiera Asystenta AI oraz funkcje wspierane przez sztuczną
            inteligencję, które mogą przetwarzać wprowadzone przez Ciebie treści (cele, zadania,
            projekty, nawyki, wpisy finansowe) w celu generowania sugestii, podsumowań i propozycji
            kolejnych kroków.
          </P>
        </Sec>
        <Sec title="Jak to działa">
          <P>
            Gdy korzystasz z funkcji AI, odpowiednie treści mogą być przesyłane do zewnętrznego
            dostawcy modeli AI wyłącznie w celu wygenerowania odpowiedzi. Nie wykorzystujemy tych
            danych do automatycznego podejmowania decyzji wywołujących wobec Ciebie skutki prawne.
          </P>
        </Sec>
        <Sec title="Twoja kontrola">
          <P>
            Funkcje AI są opcjonalne. Możesz z nich nie korzystać, po prostu nie używając
            Asystenta AI.
          </P>
        </Sec>
        <Sec title="Charakter sugestii">
          <P>
            Sugestie AI mają charakter pomocniczy i informacyjny. Nie stanowią porady finansowej,
            prawnej ani medycznej.
          </P>
        </Sec>
        <Sec title="Kontakt">
          <P>
            Pewnosc Siebie AI · {CONTACT_EMAIL} · {SITE_URL}
          </P>
        </Sec>
      </Lang>

      <Divider />

      <Lang code="EN" label="English">
        <Sec title="AI features in the App">
          <P>
            Life Leverage OS includes an AI Assistant and AI-powered features that may process the
            content you enter (goals, tasks, projects, habits, finance entries) to generate
            suggestions, summaries and next steps.
          </P>
        </Sec>
        <Sec title="How it works">
          <P>
            When you use AI features, the relevant content may be sent to a third-party AI model
            provider solely to generate a response. We do not use this data for automated
            decision-making that produces legal effects concerning you.
          </P>
        </Sec>
        <Sec title="Your control">
          <P>AI features are optional. You can choose not to use them by not using the AI Assistant.</P>
        </Sec>
        <Sec title="Nature of suggestions">
          <P>
            AI suggestions are assistive and informational only. They do not constitute financial,
            legal or medical advice.
          </P>
        </Sec>
        <Sec title="Contact">
          <P>
            Pewnosc Siebie AI · {CONTACT_EMAIL} · {SITE_URL}
          </P>
        </Sec>
      </Lang>
    </LegalLayout>
  );
}
